import { RouteRecordRaw } from "vue-router";
import { GET_AWARD_PROCEDURE_AS_CURRENT } from "@/store/modules/awardProcedure.actions";
import LoadingService from "@/service/LoadingService";
import i18n from "@/i18n";
import {
  UPDATE_CURRENT_SHIPMENT,
  UPDATE_ALL_SHIPMENTS,
} from "@/store/modules/shipment.actions";
import Breadcrumbs from "@/router/breadcrumbs";
import { ROUTE_SHIPMENT_DETAILS, ROUTE_SHIPMENT_LIST } from "@/router/routes";

const Shipments = () =>
  import(
    /* webpackChunkName: "documents-chunk" */ "@/views/shipments/shipment-frame.vue"
  );
const ShipmentList = () =>
  import(
    /* webpackChunkName: "documents-chunk" */ "@/views/shipments/shipment-list.vue"
  );
const ShipmentDetails = () =>
  import(
    /* webpackChunkName: "documents-chunk" */ "@/views/shipments/shipment-details.vue"
  );

export default {
  path: "shipments",
  component: Shipments,
  beforeEnter(to, from, next) {
    LoadingService.addLoadAction(UPDATE_ALL_SHIPMENTS, {
      awardProcedureId: to.params.awardProcedureId,
    });
    LoadingService.addLoadAction(
      GET_AWARD_PROCEDURE_AS_CURRENT,
      to.params.awardProcedureId
    ); //weil die create-tender-documents action hier dran hängt
    next();
  },
  meta: {
    title: i18n.global.t("route-titles.documents"),
  },
  children: [
    {
      path: "",
      name: ROUTE_SHIPMENT_LIST,
      component: ShipmentList,
      meta: {
        breadCrumbs: Breadcrumbs.TenderDocuments,
        title: i18n.global.t("route-titles.documents"),
        loadRoute(dispatcher, { awardProcedureId }) {
          //Da wir das Listen neu Laden auch außerhalb des Routers ausführen müssen
          //wenn wir auf der Liste Elemente löschen
          //Lagern wir das Laden allgemein aus
          return [
            dispatcher.dispatch(UPDATE_ALL_SHIPMENTS, {
              awardProcedureId,
            }),
            dispatcher.dispatch(
              GET_AWARD_PROCEDURE_AS_CURRENT,
              awardProcedureId
            ),
          ];
        },
      },
      beforeEnter(to, from, next) {
        to.meta!.loadRoute!(LoadingService, to.params);
        next();
      },
    },
    {
      path: ":shipmentId",
      name: ROUTE_SHIPMENT_DETAILS,
      component: ShipmentDetails,
      beforeEnter(to, from, next) {
        LoadingService.addLoadAction(UPDATE_CURRENT_SHIPMENT, {
          shipmentId: to.params.shipmentId,
        });
        next();
      },
      meta: {
        title: i18n.global.t("route-titles.documents"),
        breadCrumbs: Breadcrumbs.TenderDocuments,
        parent: ROUTE_SHIPMENT_LIST,
      },
    },
  ],
} as RouteRecordRaw;
